


function BannerFooter({ imageone, imagetwo, title, text }) {
  return (
    <>
    <style>
  {`
    /* Base styles for large screens */
    .cardbannerimage {
      width: 100%;
      height: 80vh; /* Set height for large screens */
      object-fit: 100% 100%; /* Ensures image fills the container while maintaining aspect ratio */
    }

    /* Adjustments for small screens */
    @media (max-width: 768px) {
      .cardbannerimage {
        height: 40vh; /* Set reduced height for small devices */
        object-fit: contain; /* Ensures the entire image is visible without cropping */
      }
    }
  `}
</style>
      <div className="container-fluid p-0">
        <div className="row m-0">
          <div className="col-12 p-0 cardbanner">
            <img src={imageone} className="w-100 cardbannerimage"
            />
          </div>
        </div>
      </div>

      <div className="container-fluid bg-black p-0">
        <div className="container py-5">
          <div className="row justify-content-center align-items-center gap-5 m-0">
            <div className="col-md-5 col-12 text-center text-md-start">
              <button className="btn btn-danger text-white my-2">Popular</button>
              <h2 className="fw-bold text-white">{title}</h2>
              <p className="text-white p-md-0 px-3 text-justify">{text}</p>
            </div>
            <div className="col-md-5 col-12">
              <img src={imagetwo} alt="img not found" className="w-100 object-fit-cover rounded" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BannerFooter;
